import { render, staticRenderFns } from "./ClientAddMachine.vue?vue&type=template&id=1d9d466a&"
import script from "./ClientAddMachine.vue?vue&type=script&lang=ts&"
export * from "./ClientAddMachine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d9d466a')) {
      api.createRecord('1d9d466a', component.options)
    } else {
      api.reload('1d9d466a', component.options)
    }
    module.hot.accept("./ClientAddMachine.vue?vue&type=template&id=1d9d466a&", function () {
      api.rerender('1d9d466a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/ClientAddMachine.vue"
export default component.exports